import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

// Track page visit
const trackVisit = async (page) => {
  try {
    const sessionId = getSessionId();
    
    await axios.post(`${API}/analytics/track/visit`, {
      page: page,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      language: navigator.language,
      screen_width: window.screen.width,
      screen_height: window.screen.height
    }, {
      headers: {
        'x-session-id': sessionId
      }
    });

    // Try to get geolocation for country (with better error handling)
    try {
      const geoResponse = await axios.get('https://ipapi.co/json/', { 
        timeout: 3000,
        withCredentials: false 
      });
      if (geoResponse.data?.country_name) {
        await axios.post(`${API}/analytics/track/location`, {
          country: geoResponse.data.country_name,
          city: geoResponse.data.city
        }, {
          headers: {
            'x-session-id': sessionId
          }
        });
      }
    } catch (geoError) {
      // Silently fail - geolocation is optional
      // CORS errors are expected in some environments
    }
  } catch (error) {
    // Silently fail - analytics should not break the app
    console.debug('Analytics tracking failed:', error);
  }
};

// Track click event
export const trackClick = async (element, elementType) => {
  try {
    const sessionId = getSessionId();
    
    await axios.post(`${API}/analytics/track/click`, {
      page: window.location.pathname,
      element: element,
      element_type: elementType
    }, {
      headers: {
        'x-session-id': sessionId
      }
    });
  } catch (error) {
    // Silently fail
    console.debug('Click tracking failed:', error);
  }
};

// Analytics Provider Component
const AnalyticsTracker = () => {
  const location = useLocation();
  const lastTrackedPath = useRef('');

  useEffect(() => {
    // Only track if path changed
    if (location.pathname !== lastTrackedPath.current) {
      lastTrackedPath.current = location.pathname;
      trackVisit(location.pathname);
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;
